<template>
  <div class="frameParent mt-4 pl-5 ml-0">
    <div class="d-inline-flex tabBorder">
      <div
        class="tab"
        v-for="(tab, i) of Object.keys(tabs)"
        v-bind:key="i"
        :class="{ activeTab: activeTab === tabs[tab] }"
        @click="activeTab = tabs[tab]"
      >
        {{ formatTabName(tab) }}
      </div>
    </div>
    <div class="frameParent" v-show="activeTab === tabs.BRANDING">
      <b class="tabTitle">Add your own branding</b>
      <div class="frameParent8">
        <div class="mainMenuLogoParent">
          <div class="branding">Main menu logo</div>
          <div class="frameChild6">
            <img
              v-if="branding.logo"
              :src="getProcessedImageUrl(branding.logo)"
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="recommended40x40pxPng">
            Recommended: 40x40px PNG with transparent background
          </div>
        </div>
        <div class="vectorParent" @click="changeBrandingLogo">
          <img class="vectorIcon1" alt="" src="/static/img/Pencil.svg" />
          <div class="branding">Change logo</div>
        </div>
        <FileUpload
          style="display: none"
          ref="fileUpload1"
          label="Aircraft Image"
          fieldId="image"
          v-model="formData.brandingLogo"
          @upload-success="handleBrandingLogoUploadSuccess"
        />
      </div>
      <div class="frameParent8">
        <div class="mainMenuLogoParent">
          <div class="branding">Email header</div>
          <textarea rows="4" v-model="branding.emailHeader" class="frameChild7">
              Change email header
          </textarea>
          <div class="recommended40x40pxPng">
            Recommended resolution 580x80px
          </div>
        </div>
        <div class="vectorParent" @click="updateBrandingEmailHeader">
          <img class="vectorIcon1" alt="" src="/static/img/Pencil.svg" />
          <div class="branding">Change email header</div>
        </div>
      </div>
    </div>

    <div class="frameParent" v-show="activeTab === tabs.FEATURES">
      <b class="tabTitle">Features</b>
      <div class="frameParent6" v-for="(value, key) in features" :key="key">
        <div class="featureTitleParent">
          <b class="branding">{{ value.heading }}</b>
          <div class="featureDescriptionText">
            {{ value.subheading }}
          </div>
        </div>
        <div class="frameParent7">
          <div class="frameParent8">
            <div class="frameWrapper">
              <div class="frameChild4"></div>
            </div>
            <div>
              <input
                type="radio"
                :id="key + 'enabled'"
                :name="key"
                :value="true"
                v-model="value.value"
                class="branding"
                @change="updateFeatures(key)"
              />
              <label :for="key + 'enabled'">Enabled</label>
            </div>
          </div>
          <div class="frameParent8">
            <div class="frameWrapper1">
              <div class="frameChild5"></div>
            </div>
            <div>
              <input
                type="radio"
                :id="key + 'disabled'"
                :name="key"
                :value="false"
                v-model="value.value"
                class="branding"
                @change="updateFeatures(key)"
              />
              <label :for="key + 'disabled'">Disabled</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="frameParent" v-show="activeTab === tabs.EVENTS_TYPE">
      <b class="tabTitle">Set Custom Events</b>
      <div class="customCreateEventTypesParent">
        <b class="customCreateEvent">Custom create event types</b>
        <div class="theseAreThe">
          These are the event types that can be applied to the schedule.
          Customizing these types ensures consistency and clarity across all
          scheduled activities.
        </div>
        <div class="noteTheseAre">
          Note: These are all billable events or activities that can be added to
          the schedule that will be charged to a customer
        </div>
        <!-- start here -->
        <div class="frameParentET">
          <draggable
            v-model="billableTypes"
            @change="updateOrder(billableTypes)"
          >
            <div
              v-for="event in billableTypes"
              :key="event.name"
              class="frameGroupET"
            >
              <div
                class="vectorParentET"
                :style="{ backgroundColor: event?.scheduledColor }"
              >
                <img
                  class="vectorIcon"
                  alt=""
                  src="/static/img/EllipsisVertical.svg"
                />
                <img
                  class="vectorIcon"
                  alt=""
                  src="/static/img/EllipsisVertical.svg"
                />
              </div>
              <div class="flightInstructionWrapper">
                <div class="flightInstruction">{{ event.name }}</div>
              </div>
            </div>
          </draggable>
        </div>
        <div>
          <button @click="openNewEventTypeModal(true)">
            <img
              style="margin-right: 10px"
              alt=""
              src="/static/img/plus-white.svg"
            />
            Add Event Type
          </button>
        </div>
        <!--end here-->
      </div>
    </div>

    <div class="frameParent" v-show="activeTab === tabs.UNBILLED_EVENTS">
      <b class="tabTitle">Set Unbillable Events</b>
      <div class="customCreateEventTypesParent">
        <b class="customCreateEvent">Custom create unbillable event types </b>
        <div class="theseAreThe">
          These are the event types that can be applied to the schedule.
          Customizing these types ensures consistency and clarity across all
          scheduled activities.
        </div>
        <div class="noteTheseAre">
          Note: These are all unbillable events or activities that can be added
          to the schedule but will not be charged to a customer
        </div>
        <div class="frameParentET">
          <draggable
            v-model="unbillableTypes"
            @change="updateOrder(unbillableTypes)"
          >
            <div
              v-for="event in unbillableTypes"
              :key="event.name"
              class="frameGroupET"
            >
              <div
                class="vectorParentET"
                :style="{ backgroundColor: event?.scheduledColor }"
              >
                <img
                  class="vectorIcon"
                  alt=""
                  src="/static/img/EllipsisVertical.svg"
                />
                <img
                  class="vectorIcon"
                  alt=""
                  src="/static/img/EllipsisVertical.svg"
                />
              </div>
              <div class="flightInstructionWrapper">
                <div class="flightInstruction">{{ event.name }}</div>
              </div>
            </div>
          </draggable>
        </div>
        <div>
          <button @click="openNewEventTypeModal(false)">
            <img
              style="margin-right: 10px"
              alt=""
              src="/static/img/plus-white.svg"
            />
            Add Event Type
          </button>
        </div>
      </div>
    </div>

    <div class="frameParent" v-show="activeTab === tabs.MEETING_SCHEDULES">
      <b class="tabTitle"
        >Meeting Schedules <img src="/static/img/info-circle.svg" height="25"
      /></b>
      <div class="customCreateEventTypesParent">
        <div class="createAndAssign">
          Create and assign meeting schedules to different teams, or personnel.
        </div>
      </div>
      <div class="vectorParent" @click="addMeeting()">
        <img class="vectorIcon1" alt="" src="/static/img/plus_icon.svg" />
        <div class="branding">Add a Meeting</div>
      </div>
      <div style="width: 100%">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Schedule</th>
              <th scope="col"></th>
              <th scope="col">Working Days</th>
              <th scope="col">Time</th>
              <th scope="col">Assigned To</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="schedule in meetingSchedules" :key="schedule.id">
              <td style="width: 18%">{{ schedule.name }}</td>
              <td style="width: 10%">
                <span :class="schedule.enabled ? 'active' : 'inactive'">
                  {{ schedule.enabled ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                <div class="d-flex">
                  <div
                    :style="{
                      color: schedule.meetSunday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Su
                  </div>
                  <div
                    :style="{
                      color: schedule.meetMonday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Mo
                  </div>
                  <div
                    :style="{
                      color: schedule.meetTuesday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Tu
                  </div>
                  <div
                    :style="{
                      color: schedule.meetWednesday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    We
                  </div>
                  <div
                    :style="{
                      color: schedule.meetThursday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Th
                  </div>
                  <div
                    :style="{
                      color: schedule.meetFriday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Fr
                  </div>
                  <div
                    :style="{
                      color: schedule.meetSaturday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Sa
                  </div>
                </div>
              </td>
              <td style="color: #3c78ff">
                <div
                  @click="editMeetingSchedule(schedule)"
                  style="cursor: pointer"
                >
                  {{ $global.getTimePartOfDate(schedule.startTime) }} -
                  {{ $global.getTimePartOfDate(schedule.endTime) }}
                </div>
              </td>
              <td>{{ schedule.assignedTo }}</td>
              <td>
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteMeetingSchedule(schedule.id)"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="frameParent" v-show="activeTab === tabs.INVOICE_TEMPLATES">
      <b class="tabTitle">Invoice Templates</b>
      <div class="customCreateEventTypesParent">
        Set up and customize invoices with your logo and company details for a
        professional touch.
      </div>
      <div style="width: 100%" class="d-flex">
        <div class="[invoiceCard, 'px-2']">
          <div class="frameParent8">
            <div class="mainMenuLogoParent">
              <div class="branding">Logo on the Invoice</div>

              <div class="frameChild6">
                <img
                  v-if="invoiceTemplate.logo"
                  :src="getProcessedImageUrl(invoiceTemplate.logo)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <div class="recommended40x40pxPng">
                Recommended: 40x40px PNG with transparent background
              </div>
            </div>
            <div class="vectorParent" @click="changeLogo">
              <img class="vectorIcon1" alt="" src="/static/img/Pencil.svg" />
              <div class="branding">Change logo</div>
            </div>
            <FileUpload
              style="display: none"
              ref="fileUpload"
              label="Aircraft Image"
              fieldId="image"
              v-model="formData.invoiceLogo"
              @upload-success="handleImageUploadSuccess"
            />
          </div>
          <div class="d-flex">
            <div class="flex-grow-1 p-1" style="flex-basis: 50%">
              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Company Name</label
                >
                <input
                  v-model="invoiceTemplate.companyName"
                  type="text"
                  id="exampleFormControlInput1"
                />
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput2" class="form-label"
                  >City</label
                >
                <input
                  v-model="invoiceTemplate.city"
                  type="text"
                  id="exampleFormControlInput2"
                />
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput3" class="form-label"
                  >Country</label
                >
                <input
                  v-model="invoiceTemplate.country"
                  type="text"
                  id="exampleFormControlInput3"
                />
              </div>
            </div>
            <div class="flex-grow-1 p-1" style="flex-basis: 50%">
              <div class="mb-3">
                <label for="exampleFormControlInput4" class="form-label"
                  >Address</label
                >
                <input
                  v-model="invoiceTemplate.address"
                  type="text"
                  id="exampleFormControlInput4"
                />
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput5" class="form-label"
                  >Postal Code</label
                >
                <input
                  v-model="invoiceTemplate.postalCode"
                  type="email"
                  id="exampleFormControlInput5"
                />
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput6" class="form-label"
                  >State</label
                >
                <input
                  v-model="invoiceTemplate.state"
                  type="email"
                  id="exampleFormControlInput6"
                />
              </div>
            </div>
          </div>
          <div>
            <button @click="saveInvoiceTemplate()">Update</button>
          </div>
        </div>
      </div>
    </div>

    <div class="frameParent" v-show="activeTab === tabs.USER_NOTIFICATIONS">
      <b class="tabTitle">Manage user notifications</b>
      <div class="customizeDefaultNotification">
        Customize default notification settings for new users. Existing users’
        settings will not be affected.
      </div>
      <div style="width: 100%">
        <!-- accordion -->
        <div style="width: 50%">
          <div :class="['header', 'd-flex']">
            <div class="px-2 d-flex align-items-center">
              <img src="/static/img/quill_mail.svg" />
            </div>
            <div class="flex-fill">
              <div style="font-weight: bold; font-size: 15px">
                Email Notifications
              </div>
              <div style="font-size: 12px; color: #404040">
                Send me a notification via email when someone ...
              </div>
            </div>
            <div
              :class="[
                'px-2',
                'd-flex',
                'align-items-center',
                'expandable',
                { ['expanded']: isExpanded },
              ]"
              style="cursor: pointer"
              @click="isExpanded = !isExpanded"
            >
              <img class="chevron" src="/static/img/chevron-down.svg" alt="" />
            </div>
          </div>
          <div :class="['accordionBody', { ['expanded']: isExpanded }]">
            <div style="padding: 15px">
              <div
                v-for="(value, key, index) in userNotifications"
                :key="key"
                class="form-check"
              >
                <label
                  class="form-check-label"
                  style="font-size: 12px; font-weight: 400"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="value.value"
                    @change="updateNotificationSetting(key)"
                  />
                  <span class="form-check-sign"></span>
                  <slot></slot>
                  {{ value.label }}
                </label>

                <hr v-if="(index + 1) % 2 === 0" />
              </div>
            </div>
          </div>
        </div>
        <!-- end of accordion -->
      </div>
    </div>

    <Modal :title="'Meeting Name & Time'" v-model="isAddingMeetingSchedule">
      <div style="width: 100%">
        <div class="row">
          <div :class="['meetingName', 'col-3']">Meeting Name</div>
          <div class="col-9">
            <input
              v-model="meetingSchedule.name"
              class="name"
              placeholder="Name..."
            />
          </div>
        </div>
        <div class="row" style="margin-top: 15px">
          <div :class="['meetingName', 'col-3']">Repeat</div>
          <div class="col-9">
            <hilo-select
              :options="[
                {
                  name: 'Weekly',
                  id: 'Weekly',
                },
                {
                  name: 'Monthly',
                  id: 'Monthly',
                },
              ]"
              theme="grey"
              placeholder="Choose One"
              :searchable="true"
              :customStyle="{
                height: '50px',
                width: '100%',
              }"
              v-model="meetingSchedule.repeat"
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="margin-top: 15px">
          <div :class="['meetingName', 'col-3']">Assigned To</div>
          <div class="col-9">
            <hilo-select
              :options="flightSchoolUsers"
              theme="grey"
              placeholder="Choose One"
              :searchable="true"
              :multi-select="true"
              :customStyle="{
                height: '50px',
                width: '100%',
              }"
              v-model="meetingSchedule.assignedTo"
            ></hilo-select>
          </div>
        </div>

        <div style="margin-top: 15px">
          <span class="scheduleName">Days</span>
          <div class="d-flex justify-content-between">
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetSunday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="meetingSchedule.meetSunday = !meetingSchedule.meetSunday"
            >
              Su
            </div>
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetMonday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="meetingSchedule.meetMonday = !meetingSchedule.meetMonday"
            >
              Mo
            </div>
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetTuesday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="
                meetingSchedule.meetTuesday = !meetingSchedule.meetTuesday
              "
            >
              Tu
            </div>
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetWednesday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="
                meetingSchedule.meetWednesday = !meetingSchedule.meetWednesday
              "
            >
              We
            </div>
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetThursday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="
                meetingSchedule.meetThursday = !meetingSchedule.meetThursday
              "
            >
              Th
            </div>
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetFriday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="meetingSchedule.meetFriday = !meetingSchedule.meetFriday"
            >
              Fr
            </div>
            <div
              :style="{
                cursor: 'pointer',
                color: meetingSchedule.meetSaturday
                  ? '#404040'
                  : 'rgba(64, 64, 64, 0.5)',
                'user-select': 'none',
              }"
              @click="
                meetingSchedule.meetSaturday = !meetingSchedule.meetSaturday
              "
            >
              Sa
            </div>
          </div>
        </div>
        <div style="margin-top: 15px">
          <span class="scheduleName">Time</span>
          <TimeRangePicker
            v-model="meetingSchedule.time"
            work-or-meet="meet"
            @input="calculateEndAMPM(meetingSchedule)"
          />
          <div class="timeSwitches">
            <div class="timeSwitch">
              {{ meetingSchedule?.time?.start }}
              <div
                class="ampmSwitch"
                @click="toggleTimeSwitch(meetingSchedule)"
              >
                <div
                  class="ampm"
                  :class="startAMPM === 'AM' ? 'selectedTime' : ''"
                >
                  AM
                </div>
                <div
                  class="ampm"
                  :class="startAMPM === 'PM' ? 'selectedTime' : ''"
                >
                  PM
                </div>
              </div>
            </div>
            <div class="timeSwitch">
              {{ meetingSchedule?.time?.end }} {{ endAMPM }}
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <button
          style="width: 100%"
          @click="
            isAddingMeetingSchedule = false;
            storeMeeting();
          "
        >
          Save
        </button>
      </template>
    </Modal>

    <Modal
      :title="`Edit Time of ${editedSchedule?.name}`"
      v-model="isEditingMeetingSchedule"
    >
      <div style="width: 100%">
        <TimeRangePicker v-model="editedSchedule.time" work-or-meet="meet" />
        <div class="timeSwitches">
          <div class="timeSwitch">
            {{ editedSchedule?.time?.start }}
            <div class="ampmSwitch" @click="toggleTimeSwitch(editedSchedule)">
              <div
                class="ampm"
                :class="startAMPM === 'AM' ? 'selectedTime' : ''"
              >
                AM
              </div>
              <div
                class="ampm"
                :class="startAMPM === 'PM' ? 'selectedTime' : ''"
              >
                PM
              </div>
            </div>
          </div>
          <div class="timeSwitch">
            {{ editedSchedule?.time?.end }} {{ endAMPM }}
          </div>
        </div>
        <br />
        <div class="text-center">
          <button @click="saveMeetingSchedule()">Save</button>
        </div>
      </div>
    </Modal>

    <Modal :title="`New Event Type`" v-model="isAddingEventType">
      <div style="width: 100%">
        <div class="row" style="margin-bottom: 10px">
          <div :class="['meetingName', 'col-3']">Name</div>
          <div class="col-9">
            <input
              v-model="newEventType.name"
              class="name"
              placeholder="Name..."
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="backgroundColorParent col-12">
            <div class="curriculumTitle">Schedule Color</div>
            <div class="color-wrapper">
              <input type="color" v-model="newEventType.scheduledColor" />
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="backgroundColorParent col-12">
            <div class="curriculumTitle">Started Color</div>
            <div class="color-wrapper">
              <input type="color" v-model="newEventType.startedColor" />
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="backgroundColorParent col-12">
            <div class="curriculumTitle">Completed Color</div>
            <div class="color-wrapper">
              <input type="color" v-model="newEventType.completedColor" />
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="backgroundColorParent col-12">
            <div class="curriculumTitle">Text Color</div>
            <div class="color-wrapper">
              <input type="color" v-model="newEventType.textColor" />
            </div>
          </div>
        </div>
        <br />
        <button style="float: right" @click="addEventTypes">Save</button>
      </div>
    </Modal>
    <ToastNotifier ref="toast" />
    <coming-soon-modal />
  </div>
</template>
<script setup>
import { ref } from "vue";
import FileUpload from "@/components/HiloComponents/FileUpload.vue";
import draggable from "vuedraggable";
import TimeRangePicker from "../../Components/TimeRangePicker.vue";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

const fileUpload1 = ref(null);
const fileUpload = ref(null);
const customizationSettings = ref({
  branding: {
    mainMenuLogo: null,
    emailHeader: null,
  },
  features: {
    title: "Feature Title",
    description: "Feature description text.",
    enabled: false,
  },
});

const tabs = Object.freeze({
  BRANDING: "branding",
  FEATURES: "features",
  EVENTS_TYPE: "eventsTypes",
  UNBILLED_EVENTS: "unbillableEvents",
  MEETING_SCHEDULES: "meetingSchedules",
  INVOICE_TEMPLATES: "invoiceTemplates",
  EMAIL_TEMPLATES: "emailTemplates",
  USER_PROFILE: "userProfile",
  USER_NOTIFICATIONS: "userNotifications",
});

const activeTab = ref(tabs.BRANDING); // default active tab to branding

function changeBrandingLogo() {
  fileUpload1.value.$children[0].$el.click();
}

function changeLogo() {
  fileUpload.value.$children[0].$el.click();
}
</script>
<script>
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import EventTypesAPIService from "../../../../servicehandlers/EventTypesAPIService";
import MeetSchedulesAPIService from "../../../../servicehandlers/MeetSchedulesAPIService";
import InvoicesAPIService from "../../../../servicehandlers/InvoiceAPIService";
import UsersAPIService from "../../../../servicehandlers/UsersAPIService";
import CustomizationSettingsAPIService from "../../../../servicehandlers/CustomizationSettingsAPIService";
import NotificationsAPIService from "../../../../servicehandlers/NotificationsAPIService";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import ToastNotifier from "@/components/ToastNotifier.vue";
import { mapState } from "pinia";
import { useLoginStore } from "@/stores/loginStore";
import { getProcessedImageUrl } from "@/util/images";
const eventTypesAPIService = new EventTypesAPIService();
const meetSchedulesAPIService = new MeetSchedulesAPIService();
const usersAPIService = new UsersAPIService();
const invoicesAPIService = new InvoicesAPIService();
const customizationSettingsAPIService = new CustomizationSettingsAPIService();
const notificationAPIService = new NotificationsAPIService();
import Modal from "../../Components/Modal.vue";
export default {
  data() {
    return {
      billableTypes: [],
      unbillableTypes: [],
      isAddingMeetingSchedule: false,
      isEditingMeetingSchedule: false,
      isAddingEventType: false,
      meetingSchedule: {
        name: null,
        repeat: null,
        assignedTo: null,
        meetMonday: false,
        meetTuesday: false,
        meetWednesday: false,
        meetThursday: false,
        meetFriday: false,
        meetSaturday: false,
        meetSunday: false,
        time: null,
      },
      meetingSchedules: [],
      flightSchoolUsers: [],
      editedSchedule: {
        time: null,
      },
      invoiceTemplate: {
        id: null,
        logo: null,
        companyName: null,
        city: null,
        country: null,
        address: null,
        postalCode: null,
        state: null,
      },
      formData: {
        invoiceLogo: null,
        brandingLogo: null,
      },
      featureId: null,
      notificationId: null,
      branding: {
        logo: null,
        emailHeader: null,
      },
      features: {
        showStudentBalance: {
          heading: "Show Student Balances",
          subheading:
            "Enable this feature to display student account balances directly on their profiles.",
          value: null,
        },
        enableAutoSchedule: {
          heading: "Enable Auto Scheduling",
          subheading:
            "Automatically assign flight slots and instructors based on availability and student progress.",
          value: null,
        },
        showInstructorAvailability: {
          heading: "Show Instructor Availability",
          subheading:
            "Allow students and admins to view instructor schedules for easier lesson booking.",
          value: null,
        },
        enableAutoPaymentRemind: {
          heading: "Enable Automated Payment Reminders",
          subheading:
            "Send automated email or SMS reminders for upcoming events",
          value: null,
        },
        enableExpiredDocNotify: {
          heading: "Enable Notifications for Expired Documents",
          subheading:
            "Notify students and instructors when uploaded documents are nearing expiration.",
          value: null,
        },
        enableLessonCancellation: {
          heading: "Enable Lesson Cancellations",
          subheading:
            "Allow office staff or admins to cancel lessons and notify all relevant parties.",
          value: null,
        },
        loanApplicationIntegration: {
          heading: "Loan Application Integration",
          subheading:
            "Allow students to apply for loans directly through the platform.",
          value: null,
        },
      },
      isExpanded: true,
      userNotifications: {
        itemAssign: { label: "Assigns me to an item", value: false },
        postMentions: { label: "Mentions me in a post or reply", value: false },
        itemOwnerUpdate: {
          label: "Writes an update on an item I'm the owner of",
          value: false,
        },
        itemSubscriberUpdate: {
          label: "Writes an update on an item I'm subscribed to",
          value: false,
        },
        conversationReplies: {
          label: "Replies to a conversation I'm a part of",
          value: false,
        },
        updateReplies: { label: "Replies to my update", value: false },
        pendingUsers: { label: "Pending Users", value: false },
        potentialStudentsApproved: {
          label: "Potential students approved for funding",
          value: false,
        },
        potentialCustomerFollowUp: {
          label: "Potential customer follow up requests",
          value: false,
        },
        checkridesScheduled: { label: "Checkrides scheduled", value: false },
        writtensCompleted: { label: "Written's completed", value: false },
        student3DaysBehind: {
          label: "Students that fall behind schedule 3 days",
          value: false,
        },
        studentGradeBelow80: {
          label: "Students that fall below a grade of 80%",
          value: false,
        },
        instructorGradeBelow80: {
          label: "Instructors that fall below a grade of 80%",
          value: false,
        },
        newCurriculumAdded: { label: "New curriculum is added", value: false },
        totalPayroll: { label: "Total payroll", value: false },
        totalRevenueForWeek: {
          label: "Total revenue for the week",
          value: false,
        },
        totalEventsForWeek: {
          label: "Total Events scheduled for the week",
          value: false,
        },
        totalEventsForDay: {
          label: "Total Events scheduled for the day",
          value: false,
        },
      },
      newEventType: {
        name: "",
        billable: null,
        scheduledColor: "#000",
        startedColor: "#000",
        completedColor: "#000",
        textColor: "#000",
      },
      startAMPM: "AM",
      endAMPM: "AM",
    };
  },
  components: {
    Modal,
    HiloSelect,
    ToastNotifier,
  },
  mounted() {
    this.getEventTypes();
    this.getSchedules();
    this.getPeopleForAssignedTo();
    this.getInvoiceTemplate();
    this.getCustomizationSettings();
    this.getNotificationSettings();
  },
  methods: {
    formatTabName(tab) {
      let words = tab.split("_");
      let string = "";
      for (let word of words) {
        string += word[0] + word.slice(1).toLowerCase() + " ";
      }
      return string;
    },
    getProcessedImageUrl,
    getEventTypes() {
      return eventTypesAPIService.get(this.$router).then((response) => {
        this.billableTypes = response.filter((data) => data.billable);
        this.unbillableTypes = response.filter((data) => !data.billable);
      });
    },
    addEventTypes() {
      if (this.newEventType.billable) {
        this.newEventType.order =
          this.billableTypes[this.billableTypes.length - 1].order + 1;
      } else {
        this.newEventType.order =
          this.unbillableTypes[this.unbillableTypes.length - 1].order + 1;
      }

      return eventTypesAPIService
        .create(this.newEventType, this.$router)
        .then(() => {
          this.getEventTypes();
          this.newEventType = {
            name: "",
            billable: null,
            scheduledColor: "#000",
            startedColor: "#000",
            completedColor: "#000",
            textColor: "#000",
          };
          this.isAddingEventType = false;
        })
        .catch((e) => {
          this.$refs.toast.showError(
            "Error while creating new event type." + e,
          );
        });
    },
    updateOrder(array) {
      for (let type of array) {
        type.order = array.indexOf(type) + 1;
        try {
          eventTypesAPIService.update(type.id, type, this.$router);
        } catch (e) {}
      }
    },
    getSchedules() {
      meetSchedulesAPIService
        .getAllMeetingSchedulesForFlightSchool(
          this.user.flightSchoolId,
          this.$router,
        )
        .then((response) => {
          this.meetingSchedules = response;
        });
    },
    addMeeting() {
      this.isAddingMeetingSchedule = true;
    },
    openNewEventTypeModal(billable) {
      this.newEventType.billable = billable;
      this.isAddingEventType = true;
    },
    storeMeeting() {
      const assignedTo = [];

      if (
        this.meetingSchedule.assignedTo &&
        this.meetingSchedule.assignedTo.length
      ) {
        for (let userId of this.meetingSchedule.assignedTo) {
          const selected = this.flightSchoolUsers.find((u) => u.id === userId);
          if (selected) assignedTo.push(selected.name);
        }
      }

      if (this.startAMPM === "AM") {
        let splitTime = this.meetingSchedule.time.start.split(":");
        if (splitTime[0] === "12") {
          this.meetingSchedule.time.start = "00:" + splitTime[1];
        }
      } else if (this.startAMPM === "PM") {
        let splitTime = this.meetingSchedule.time.start.split(":");
        if (splitTime[0] !== "12") {
          this.meetingSchedule.time.start =
            parseInt(splitTime[0]) + 12 + ":" + splitTime[1];
        }
      }
      if (this.endAMPM === "AM") {
        let splitTime = this.meetingSchedule.time.end.split(":");
        if (splitTime[0] === "12") {
          this.meetingSchedule.time.end = "00:" + splitTime[1];
        }
      } else if (this.endAMPM === "PM") {
        let splitTime = this.meetingSchedule.time.end.split(":");
        if (splitTime[0] !== "12") {
          this.meetingSchedule.time.end =
            parseInt(splitTime[0]) + 12 + ":" + splitTime[1];
        }
      }

      meetSchedulesAPIService
        .createMeetSchedule(
          {
            flightSchoolId: this.user.flightSchoolId,
            name: this.meetingSchedule.name,
            enabled: true,
            meetMonday: this.meetingSchedule.meetMonday,
            meetTuesday: this.meetingSchedule.meetTuesday,
            meetWednesday: this.meetingSchedule.meetWednesday,
            meetThursday: this.meetingSchedule.meetThursday,
            meetFriday: this.meetingSchedule.meetFriday,
            meetSaturday: this.meetingSchedule.meetSaturday,
            meetSunday: this.meetingSchedule.meetSunday,
            startTime: `1900-01-01 ${this.meetingSchedule.time.start}`,
            endTime: `1900-01-01 ${this.meetingSchedule.time.end}`,
            assignedTo: assignedTo.join(", "),
            frequency: this.meetingSchedule.repeat,
          },
          this.$router,
        )
        .then((response) => {
          this.meetingSchedules.push(response);
          this.meetingSchedule = {
            name: null,
            repeat: null,
            assignedTo: null,
            meetMonday: false,
            meetTuesday: false,
            meetWednesday: false,
            meetThursday: false,
            meetFriday: false,
            meetSaturday: false,
            meetSunday: false,
            time: null,
          };
          this.startAMPM = "AM";
          this.endAMPM = "AM";
        });
    },

    deleteMeetingSchedule(id) {
      meetSchedulesAPIService.deleteMeetSchedule(id, this.$router).then(() => {
        this.getSchedules();
      });
    },

    editMeetingSchedule(schedule) {
      this.editedSchedule = schedule;
      this.editedSchedule.time = {
        start: this.$global.getTimePartOfDate(schedule.startTime),
        end: this.$global.getTimePartOfDate(schedule.endTime),
      };
      this.calculateEndAMPM(this.editedSchedule);
      this.isEditingMeetingSchedule = true;
    },

    saveMeetingSchedule() {
      meetSchedulesAPIService
        .updateMeetSchedule(
          this.editedSchedule.id,
          {
            startTime: `1900-01-01 ${this.editedSchedule.time.start}`,
            endTime: `1900-01-01 ${this.editedSchedule.time.end}`,
          },
          this.$router,
        )
        .then(() => {
          this.getSchedules();
          this.isEditingMeetingSchedule = false;
          this.editedSchedule = {
            time: null,
          };
        });
    },

    getPeopleForAssignedTo() {
      if (!this.user?.flightSchoolId) return;
      return usersAPIService
        .getAllUsersOfFlightSchool(this.user.flightSchoolId, this.$router)
        .then((response) => {
          this.flightSchoolUsers = response.map((user) => ({
            id: user.id,
            name: user.firstName + " " + user.lastName,
          }));
        });
    },

    saveInvoiceTemplate() {
      const body = {
        flightSchoolId: this.user.flightSchoolId,
        companyName: this.invoiceTemplate.companyName,
        city: this.invoiceTemplate.city,
        country: this.invoiceTemplate.country,
        address: this.invoiceTemplate.address,
        zipCode: this.invoiceTemplate.postalCode,
        state: this.invoiceTemplate.state,
        logoURL: this.invoiceTemplate.logo,
      };

      const func = this.invoiceTemplate.id
        ? invoicesAPIService.updateInvoiceTemplate(
            this.invoiceTemplate.id,
            body,
            this.$router,
          )
        : invoicesAPIService.createInvoiceTemplate(body, this.$router);

      func.then(() => {
        this.$refs.toast.showSuccess("Invoice template updated successfully");
      });
    },

    getInvoiceTemplate() {
      invoicesAPIService
        .getAllInvoiceTemplates(this.$router)
        .then((response) => {
          if (response.length) {
            const found = response.find(
              (template) =>
                template.flightSchoolId === this.user.flightSchoolId,
            );

            if (found) {
              this.invoiceTemplate = {
                id: found.id,
                logo: found.logoURL,
                companyName: found.companyName,
                city: found.city,
                country: found.country,
                address: found.address,
                postalCode: found.zipCode,
                state: found.state,
              };
            }
          }
        });
    },

    getCustomizationSettings() {
      if (!this.user?.flightSchoolId) return;

      customizationSettingsAPIService
        .getCustomizationSettingByFlightSchoolId(
          this.user.flightSchoolId,
          this.$router,
        )
        .then((response) => {
          this.featureId = response.id;
          this.features.showStudentBalance.value = response.showStudentBalance;
          this.features.enableAutoSchedule.value = response.enableAutoSchedule;
          this.features.showInstructorAvailability.value =
            response.showInstructorAvailability;
          this.features.enableAutoPaymentRemind.value =
            response.enableAutoPaymentRemind;
          this.features.enableExpiredDocNotify.value =
            response.enableExpiredDocNotify;
          this.features.enableLessonCancellation.value =
            response.enableLessonCancellation;
          this.features.loanApplicationIntegration.value =
            response.loanApplicationIntegration;
          this.branding.emailHeader = response.emailHeader;
          this.branding.logo = response.logoURL;
        });
    },

    async handleImageUploadSuccess(file) {
      try {
        if (!this.invoiceTemplate.id) throw new Error("No invoice template ID");
        const formData = new FormData();
        formData.append("image", file);

        const response = await invoicesAPIService.updateInvoiceTemplateLogo(
          this.invoiceTemplate.id,
          formData,
        );

        this.getInvoiceTemplate();
      } catch (error) {
        this.$refs.toast.showError("Failed to upload image.");
      }
    },

    async handleBrandingLogoUploadSuccess(file) {
      try {
        if (!this.featureId) throw new Error("No invoice template ID");
        const formData = new FormData();
        formData.append("image", file);

        const response =
          await customizationSettingsAPIService.updateCustomizationSettingLogo(
            this.featureId,
            formData,
          );

        this.getCustomizationSettings();
      } catch (error) {
        this.$refs.toast.showError("Failed to upload image.");
      }
    },

    updateFeatures(key) {
      customizationSettingsAPIService
        .updateCustomizationSetting(
          this.featureId,
          {
            [key]: this.features[key].value,
          },
          this.$router,
        )
        .catch((e) => {
          this.$refs.toast.showError("Failed to update feature.");
        });
    },

    updateBrandingEmailHeader() {
      customizationSettingsAPIService
        .updateCustomizationSetting(
          this.featureId,
          {
            emailHeader: this.branding.emailHeader,
          },
          this.$router,
        )
        .then(() => {
          this.$refs.toast.showSuccess("Email header updated successfully");
        })
        .catch((e) => {
          this.$refs.toast.showError("Failed to update branding.");
        });
    },

    getNotificationSettings() {
      if (!this.user?.flightSchoolId) return;

      notificationAPIService
        .getDefaultNotificationSettingByFlightSchoolId(
          this.user.flightSchoolId,
          this.$router,
        )
        .then((response) => {
          this.notificationId = response.id;
          for (const key in this.userNotifications) {
            if (response[key]) {
              this.userNotifications[key].value = !!response[key];
            }
          }
        });
    },

    updateNotificationSetting(key) {
      if (!this.notificationId) return;

      notificationAPIService
        .updateDefaultNotificationSetting(
          this.notificationId,
          {
            [key]: this.userNotifications[key].value,
          },
          this.$router,
        )
        .catch((e) => {
          this.$refs.toast.showError("Failed to update notification setting.");
        });
    },
    toggleTimeSwitch(object) {
      if (this.startAMPM === "AM") {
        this.startAMPM = "PM";
      } else {
        this.startAMPM = "AM";
      }
      this.calculateEndAMPM(object);
    },
    calculateEndAMPM(object) {
      const startTime = dayjs(object.time.start, "HH:mm");
      const endTime = dayjs(object.time.end, "HH:mm");
      if (startTime.isAfter(endTime)) {
        if (this.startAMPM === "AM") this.endAMPM = "PM";
        else if (this.startAMPM === "PM") this.endAMPM = "AM";
      } else {
        this.endAMPM = this.startAMPM;
      }
    },
  },
  computed: {
    ...mapState(useLoginStore, ["user"]),
  },
};
</script>
<style scoped>
.timeSwitch {
  display: flex;
  gap: 20px;
}
.ampm {
  padding: 2px 7px;
  font-size: 16px;
  color: #8f8f8f;
}
.selectedTime {
  background-color: #3c78ff;
  border-radius: 10px;
  box-shadow: grey 0 0 5px;
  color: white;
}
.ampmSwitch {
  background-color: #dddddd;
  border-radius: 10px;
  display: flex;
  right: 0;
  top: 0;
  cursor: pointer;
}
.timeSwitches {
  display: flex;
  justify-content: space-evenly;
  margin-top: 15px;
}
.scheduleName {
  color: rgba(0, 0, 0, 50%);
  font-weight: bold;
  font-size: 16px;
}
.active {
  background-color: #bdd7bc;
  border-radius: 10px;
  padding: 5px 10px;
}
.inactive {
  background-color: #d7bcbc;
  border-radius: 10px;
  padding: 5px 10px;
}
.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}
/* Tab styling */
.tab:hover {
  cursor: pointer;
}

.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}

.tab {
  position: relative;
  padding: 15px 25px;
  font-size: 16px;
}

.tab:focus-within {
  border-bottom: 2px solid #3c78ff;
}

.tab.activeTab::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  border-bottom: 2px solid #3c78ff;
}
.backgroundColorParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.color-wrapper {
  width: 60px;
  height: 50px;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  margin: 10px;
}

input[type="color"] {
  width: 80px;
  height: 70px;
  background: transparent;
  padding: 0;
  cursor: pointer;
  margin: -10px;
}
.branding {
  position: relative;
  white-space: nowrap;
}
.brandingWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 25px;
  font-size: 12px;
  cursor: pointer;
}
.frameChild {
  align-self: stretch;
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 3px;
}
.frameContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.eventsTypes {
  position: relative;
  white-space: nowrap;
}
.frameGroup {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
}
.tabTitle {
  position: relative;
  font-size: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.frameChild6 {
  width: 40px;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 40px;
}
.recommended40x40pxPng {
  position: relative;
  font-size: 12px;
  color: rgba(64, 64, 64, 0.75);
}
.mainMenuLogoParent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.vectorIcon1 {
  width: 14px;
  position: relative;
  height: 14px;
}
.vectorParent {
  border-radius: 10px;
  background-color: #3c78ff;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 15px;
  box-sizing: border-box;
  gap: 10px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}
.frameParent8 {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
}
.frameChild7 {
  width: 580px;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 80px;
}
.frameParent {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  box-sizing: border-box;
  gap: 25px;
  text-align: left;
  font-size: 15px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
input[type="radio"] {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  margin-right: 8px;
  background-color: #fff;
  position: relative;
  border-radius: 50%;
  cursor: pointer;
}

input[type="radio"]:checked {
  background-color: #3c78ff; /* Change this to your desired color */
}

input[type="radio"]:checked::before {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  top: 3px;
  left: 3px;
}

.customCreateEvent {
  position: relative;
  font-size: 15px;
}
.theseAreThe {
  align-self: stretch;
  position: relative;
  color: rgba(64, 64, 64, 0.75);
}
.noteTheseAre {
  align-self: stretch;
  position: relative;
  font-style: italic;
}
.customCreateEventTypesParent {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  text-align: left;
  font-size: 12px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}

.vectorIcon {
  width: 3px;
  position: relative;
  height: 13.3px;
  object-fit: contain;
  bottom: 0;
  right: 0;
}
.vectorParentET {
  align-self: stretch;
  width: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.flightInstruction {
  position: relative;
}
.flightInstructionWrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 15px;
}
.frameGroupET {
  width: 400px;
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 5px;
}

.frameParentET {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  text-align: left;
  font-size: 15px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}

.customizeDefaultNotification {
  width: 100%;
  position: relative;
  font-size: 12px;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  text-align: left;
  display: inline-block;
}

.createAndAssign {
  position: relative;
  font-size: 12px;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  text-align: left;
}

.meetingName {
  margin-top: 10px;
  position: relative;
  font-size: 18px;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  text-align: left;
  display: inline-block;
}

.name {
  position: relative;
}
.nameParent {
  flex: 1;
  width: 100%;
  position: relative;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  text-align: left;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
  font-family: Helvetica, Arial, sans-serif;
}

.invoiceCard {
  position: relative;
  border-radius: 15px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  width: 50%;
  padding: 25px 0px;
  text-align: left;
  font-size: 15px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
.header {
  border-radius: 10px 10px 0px 0px;
  width: 100%;
  padding: 10px;
  background-color: rgba(64, 64, 64, 0.05);
}

.expandable {
  .chevron {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  &.expanded {
    .chevron {
      transform: rotate(0deg);
    }
  }
}

.accordionBody {
  border-radius: 0px 0px 10px 10px;
  border-right: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  border-left: 1px solid #dedede;
  background: rgba(255, 255, 255, 0.05);
  max-height: 0;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
  overflow: hidden;

  &.expanded {
    max-height: 1000px;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 1, 1);
  }
}

.checkboxGroup {
  display: flex;
}
</style>
